export default {
  className: 'banner',
  fields: [
    {
      name: 'banner',
      validators: [
        (value) => value ? null : '不可为空'
      ]
    }
  ],
  search: [
    'imgType'
  ],
  action: {
    export: false,
    delete: {

    }
  },
  hooks: {
    beforeInsert ({ data }) {
      data.imgType = 'carousel'
    }
  }
}
